import SavingThrowSelectionSmallBoxSvg from "./SavingThrowSelectionSmallBoxSvg";

export default SavingThrowSelectionSmallBoxSvg;
